import { connect } from 'react-redux';
import { constant } from '../../../Utils/constants';
import { Form, message, DatePicker, Select,Button } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';

import {
  submitJobPlan,
  // getJobPlanById
} from '../../../Utils/FormCalls';

const FailureReport = (props) => {
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  const schedulingWorkOrderRef = useRef();

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      schedulingWorkOrderRef.current.setFieldsValue(props.formObject);
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }

    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
  }, [props, formObject, translationCache]);

  const handleChange = (value, key) => {
    const updatedFormObject = {
      ...formObject,
      [key]: value
    };
    schedulingWorkOrderRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
  };

  const onFinish = async (values) => {
    const payload = {
      ...formObject,
      ...values
    };
    const statusResponse = await submitJobPlan(payload);

    if (statusResponse?.message) {
      message.success(statusResponse.message);
      onReset();
    } else if (statusResponse?.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    schedulingWorkOrderRef.current.resetFields();
  };

  return (
    <>
      <Form
        onFinish={onFinish}
        name={'FailureReport'}
        ref={schedulingWorkOrderRef}
        className="jobplan"
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item
            label={translation(translationCache, constant.failureClass)}
            name="FailureClass"
            onChange={(value) => handleChange(value, 'FailureClass')}
            rules={[{ required: false, message: 'Please Input FailureClass!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <Select style={{ width: '70%' }}></Select>
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.date)}
            name="Date"
            onChange={(value) => handleChange(value, 'Date')}
            style={{ width: '100%', flex: '50%' }}
            rules={[{ required: false, message: 'Please Input Date!' }]}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              style={{ width: '70%' }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.failureCode)}
            name="FailureCode"
            style={{ width: '100%', flex: '50%' }}
            onChange={(value) => handleChange(value, 'FailureCode')}
            rules={[{ required: false, message: 'Please Input FailureCode!' }]}
          >
            <Select style={{ width: '70%' }}></Select>
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.problem)}
            name="Problem"
            style={{ width: '100%', flex: '50%' }}
            onChange={(value) => handleChange(value, 'Problem')}
            rules={[{ required: false, message: 'Please Input Problem!' }]}
          >
            <Select style={{ width: '70%' }}></Select>
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.cause)}
            name="Cause"
            style={{ width: '100%', flex: '50%' }}
            onChange={(value) => handleChange(value, 'Cause')}
            rules={[{ required: false, message: 'Please Input Cause!' }]}
          >
            <Select style={{ width: '70%' }}></Select>
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.remedy)}
            name="Remedy"
            style={{ width: '100%', flex: '50%' }}
            onChange={(value) => handleChange(value, 'Remedy')}
            rules={[{ required: false, message: 'Please Input Remedy!' }]}
          >
            <Select style={{ width: '70%' }}></Select>
          </Form.Item>
        </div>

        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button htmlType="submit">
              {translation(translationCache, constant.save)}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(FailureReport);